import React, { useState } from 'react';
import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';
import _keyBy from 'lodash/keyBy';
import makeStyles from '@material-ui/core/styles/makeStyles';
import * as AttributeEditTypes from 'pages/AttributesEdit/typings';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';

interface Props {
  values: AttributeEditTypes.AttributesEditFormValues;
  onChange: (field: string, value: any) => void;
}

function DefaultLandingPage({ values, onChange }: Props) {
  const classes = useStyles();
  const landingPageValue = _get(values, ['client', 'settings', 'landingPage'], 'homepage');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    onChange('client.settings.landingPage', value);
  };

  return (
    <Card>
      <CardHeader
        className={classes.header}
        title="Landing Page"
        subheader="Choose which page users will land on when they sign in or navigate to the root URL of your Sift instance."
      />
      <CardContent>
        <RadioGroup value={landingPageValue} onChange={handleChange}>
          <FormControlLabel
            control={<Radio />}
            value="homepage"
            label={
              <>
                <strong>Homepage/Search (Default)</strong> - A large search bar for free-text search
                and any configured homepage widgets.
              </>
            }
          />
          <FormControlLabel
            control={<Radio />}
            value="org-chart"
            label={
              <>
                <strong>Org Chart</strong> - The org chart page.
              </>
            }
          />
          <FormControlLabel
            control={<Radio />}
            value="directory"
            label={
              <>
                <strong>Directory</strong> - The directory page, showing the full list of employee
                profiles.
              </>
            }
          />
        </RadioGroup>
      </CardContent>
    </Card>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  header: {
    paddingBottom: 0,
  },
}));

export default DefaultLandingPage;
